import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import Luxury from "./Luxury";
import { Header } from './Header';
import { Footer } from './Footer';

export default class Luxurious extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'luxury',
            data: null,
            loading: true,
            configName: 'luxuryies_grid',
            moduleName: 'فاخر',
            id: 1
        };
        this.state.filters = {
            templateId: this.getCurrentFormId()
        }
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id, isTemplate) {
        this.showComponents({ component: <Luxury IsTemplate={isTemplate} TemplateId={this.state.filters.templateId} Caller={this} Id={id} /> });
    }
    onAdd(isTemplate) {
        this.removeKeyDown();
        this.showComponents({ component: <Luxury IsTemplate={isTemplate} TemplateId={this.state.filters.templateId} Caller={this} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "serial", caption: "شماره ثبت", show: true },
                { field: "applicantName", caption: "مشتری", show: true },
                { field: "typeTitle", caption: "نوع سنگ", show: true },
                { field: "kindTitle", caption: "نوع تراش", show: true },
                { field: "weightTitle", caption: "نوع وزن", show: true },
                { field: "isTemplate", caption: "الگو است", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'serial' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id, props.data.isTemplate)}>{props.data.serial}</a> } });
            if (f.field == 'applicantName' && f.show) t.push({flex: 2, field: f.field, headerName: f.caption });
            if (f.field == 'typeTitle' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'kindTitle' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'weightTitle' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'isTemplate' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return props.data.isTemplate ? <span className="text-danger">بله</span> : <span className="text-success">خیر</span> } });            
        });
        t.push({
            field: "", headerName: "", cellRenderer: (props) => {
                return <>
                    <a className="hand" onClick={e => this.exportMe(props.data.id, "pdf")}><em className="icon ni ni-file-pdf" style={{"font-size": "19px"}}></em></a>
                    <a className="hand" onClick={e => this.exportMe(props.data.id, "print")}><em className="icon ni ni-printer" style={{ "font-size": "19px" }}></em></a>
                </>
            }
        });
        return t;
    }
    exportMe(id, format) {

        this.httpPost("api/v1/luxury/print", {
            ids: [id],
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    if (format == 'pdf') this.downloadPDF(data.bs64);
                    if (format == 'print') this.state.printBs64 = data.bs64;
                    this.setState({
                        loading: false
                    })
                }
                else {
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="nk-content-body">
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                        <div className="card-inner p-0">
                            <div style={{ "padding": "2px 5px" }}>
                                <a className="btn btn-primary" onClick={e => this.onAdd(false)}>شناسنامه جدید</a>
                                <a className="btn btn-warning ms-2" onClick={e => this.onAdd(true)}>تمپلیت جدید</a>
                                <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onRemove()} title="حذف">
                                    <em style={{ "fontSize": "1.8rem" }} className="icon ni ni-trash"></em>
                                </a>
                                <a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onExportAll()} title="چاپ">
                                    <em style={{ "fontSize": "1.8rem" }} className="icon ni ni-printer"></em>
                                </a>
                            </div>
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}